export const SDK_VERSION = '3.2244.22';